import { useSetAtom } from "jotai";
import type { StatusModalData } from "./atoms";
import { statusModalDataAtom } from "./atoms";
import { useModals } from "src/components/Modals";

export const useStatusModal = () => {
  const setStatusModalData = useSetAtom(statusModalDataAtom);
  const { openModal, closeModal } = useModals();

  const openStatusModal = (data: StatusModalData) => {
    setStatusModalData(data);
    openModal("StatusModal");
  };

  const closeStatusModal = () => {
    setStatusModalData(null);
    closeModal("StatusModal");
  };

  return {
    openStatusModal,
    closeStatusModal,
  };
};
